// extracted by mini-css-extract-plugin
export default {"btn":"_3y3b0","flexWrapper":"_3vhvu"};